/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function RollBack({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#RollBack_svg__a)"><path d="M5.237 1a.6.6 0 0 1 .6-.6H9.22a.6.6 0 1 1 0 1.2H5.837a.6.6 0 0 1-.6-.6M10.9 1a.6.6 0 0 1 .6-.6A2.6 2.6 0 0 1 14.1 3a.6.6 0 1 1-1.2 0 1.4 1.4 0 0 0-1.4-1.4.6.6 0 0 1-.6-.6" /><path d="M3.5 1.6A1.4 1.4 0 0 0 2.1 3v10a1.4 1.4 0 0 0 1.4 1.4h7.433c.688 0 1.36-.2 1.93-.575a3.4 3.4 0 0 0 1.274-1.527 3.34 3.34 0 0 0 .197-1.96 3.4 3.4 0 0 0-.946-1.739 3.5 3.5 0 0 0-1.777-.933 3.53 3.53 0 0 0-2.008.194 3.45 3.45 0 0 0-1.556 1.255c-.37.544-.57 1.18-.581 1.831l1.199-.68a.61.61 0 0 1 .825.22.59.59 0 0 1-.218.814L6.756 12.73a.61.61 0 0 1-.825-.221l-1.453-2.475a.59.59 0 0 1 .218-.813.61.61 0 0 1 .826.22l.752 1.282c.05-.814.319-1.602.78-2.281A4.65 4.65 0 0 1 9.15 6.749a4.73 4.73 0 0 1 3.75.08V5.5a.6.6 0 1 1 1.2 0v2.121q.066.06.13.123a4.6 4.6 0 0 1 1.28 2.357 4.54 4.54 0 0 1-.267 2.663 4.6 4.6 0 0 1-1.721 2.063A4.7 4.7 0 0 1 11 15.6H3.5A2.6 2.6 0 0 1 .9 13V3A2.6 2.6 0 0 1 3.5.4a.6.6 0 1 1 0 1.2" /></g><defs><clipPath id="RollBack_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;